import React from 'react';
import { Link } from 'react-router-dom';

const CTASection = () => (
  <section className="relative py-20 md:py-24 overflow-hidden bg-cover bg-center"
    style={{ backgroundImage: 'linear-gradient(rgba(43,190,207,0.92), rgba(43,190,207,0.92)), url(https://images.pexels.com/photos/6368521/pexels-photo-6368521.jpeg?auto=compress&cs=tinysrgb&w=1920)' }}>
    <div className="max-w-[1200px] mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-8 text-white">
      <h2 className="heading-display text-3xl md:text-5xl font-bold text-center md:text-left">
        Want to support our initiative?
      </h2>
      <Link to="/contact" className="bg-[#F97559] hover:bg-[#e65a40] px-9 py-4 font-semibold rounded-sm text-base shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all">
        Let&rsquo;s Make It Happen
      </Link>
    </div>
  </section>
);

export default CTASection;
